export interface User {
    id: number;
    name: string;
    email: string;
    image: string;
    fullName?: string //added for internal use
    profilePicture?: File;
    profilePictureUrl?: string;
    role_id: number;
}

export type LikeRequestBody = {
    user_email: string;
    user_name: string;
    user_image?: string;
    liked: boolean;
}


export interface Reply {
    id: number;
    message: string;
    approved: boolean;
    like_count: number;
    user: User;
}

export interface PollOption {
    id: number;
    option_text: string;
    user_voted: boolean;
    vote_count: number;
    vote_percentage: number;
}

export interface PollVoteRequestBody {
    user_email: string;
    user_name: string;
    user_image?: string;
    poll_option_id: number;
}

export interface Comment {
    id: number;
    message: string;
    approved: boolean;
    like_count: number;
    user: User;
    replies: Reply[];
    liked: boolean;
    primary: boolean;
    poll_options?: PollOption[]
    message_type_id?: number;
    user_voted?: boolean;
    total_votes?: number;
}


export interface CommentsResponse {
    limit: number;
    offset: number;
    total: number;
    data: Comment[];
}

export type WidgetDisplaySettings = {
    condition?: null,
    action?: null,
    url_pattern?: null,
}

export type Product = {
    product_id: string;
    name: string;
    store_id: number;
    image: string;
    category: string;
    url: string;
    live_date: string;
    post_purchase_pop_up_message: string;
    post_purchase_pop_up_title: string;
    post_purchase_pop_up_success_message: string;
    proactive_timer: number;
    proactive_appearance_timer: number;
    default_proactive_message: string;
    default_proactive_title: string;
    initial_comment_message: string;
    initial_comment_title: string;
    id: number;
    primary_comment_id: number;
    widget_id: string;
    message_count: number;
    pending_message_count: number;
    like_count: number;
    extra_info: Record<string, unknown>;
    default_review_prompt_message: string;
    interaction_time: number;
    comment_widget_display_settings: WidgetDisplaySettings;
    feedback_widget_display_settings: WidgetDisplaySettings;
    widget_theme?: null | string,
    widget_position?: string,
};

export interface UserFormState {
  isOpen: boolean;
  commentText?: string;
  label?: string;
  additionalPayload?: Record<string, unknown>;
  onSuccess?: (user: Partial<User>) => void;
  onClose?: () => void;
}

export interface State {
    data: CommentsResponse;
    selectedCommentId: number | string;
    productInfo: Product | undefined;
    widgetId: string | undefined | null;
    metaTags:  { [key: string]: string }
    themeMode: string;
    loading: boolean;
    hideWidget: boolean;
    userForm: UserFormState;
}

export const MessateTypeId = {
    COMMENT: 1,
    FEEDBACK: 2
}
export type MessageType = 1 | 2


export type CommentRequest = {
    user_email: string;
    user_name: string;
    user_image?: string;
    message: string;
    parent_review_id: number | null;
    anonymous_email?: string;
    message_type_id?: MessageType;
};
export type Action =
  | { type: 'SET_COMMENTS'; payload: CommentsResponse }
  | { type: 'ADD_COMMENT'; payload: Comment }
  | { type: 'REMOVE_COMMENT'; payload: number }
  | { type: 'ADD_REPLY'; payload: { commentId: number; reply: Reply } }
  | { type: 'REMOVE_REPLY'; payload: { commentId: number; replyId: number } }
  | { type: 'SELECT_COMMENT'; payload: { commentId: number | string } }
  | { type: 'SET_PRODUCT_INFO'; payload: { product: Product } }
  | { type: 'SET_WIDGET_ID'; payload: { widgetId: string | undefined | null } }
  | { type: 'SET_META_TAGS', payload: { [key: string]: string}}
  | { type: 'SET_THEME_MODE', payload: { mode: string } }
  | { type: 'GET_COMMENTS' } | { type: 'HIDE_WIDGET' }
  | { type: 'OPEN_USER_FORM'; payload: { 
      commentText?: string;
      label?: string;
      onSuccess?: (user: Partial<User>) => void;
      onClose?: () => void;
    } }
  | { type: 'CLOSE_USER_FORM' };